import { render, staticRenderFns } from "./UpdateBusinessMemberField.vue?vue&type=template&id=2de685a0&"
import script from "./UpdateBusinessMemberField.vue?vue&type=script&lang=js&"
export * from "./UpdateBusinessMemberField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports